import { render, staticRenderFns } from "./SystemSettingsAppVersion.vue?vue&type=template&id=466161ca"
import script from "./SystemSettingsAppVersion.vue?vue&type=script&lang=js"
export * from "./SystemSettingsAppVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports